import { declareFont, defineFont, fontWeights, Font } from '../utils/FontUtils'

const prefix = process.env.ASSET_PREFIX || ''

type Declarations = {
  [key: string]: Font
}

type Fonts = {
  [key: string]: string
}

export const declaration: Declarations = {
  Marianne: {
    basename: 'Marianne',
    fontFamily: 'Marianne',
    fontWeight: fontWeights.regular,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  MarianneBold: {
    basename: 'Marianne-Bold',
    fontFamily: 'Marianne',
    fontWeight: fontWeights.bold,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  MarianneMedium: {
    basename: 'Marianne-Medium',
    fontFamily: 'Marianne',
    fontWeight: fontWeights.medium,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  HelveticaNeue: {
    basename: 'HelveticaNeue',
    fontFamily: 'HelveticaNeue',
    fontWeight: fontWeights.regular,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  HelveticaNeueBold: {
    basename: 'HelveticaNeue-Bold',
    fontFamily: 'HelveticaNeue',
    fontWeight: fontWeights.bold,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  HelveticaNeueMedium: {
    basename: 'HelveticaNeue-Medium',
    fontFamily: 'HelveticaNeue',
    fontWeight: fontWeights.medium,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  HelveticaNeueLt: {
    basename: 'HelveticaNeue-Lt',
    fontFamily: 'HelveticaNeue',
    fontWeight: fontWeights.light,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
  HelveticaNeueBoldCondensed: {
    basename: 'HelveticaNeue-BoldCondensed',
    fontFamily: 'HelveticaNeue-Condensed',
    fontWeight: fontWeights.bold,
    fallback: 'Helvetica Neue, Helvetica, Arial, sans-serif;',
    prefix,
  },
}

export const fontsFaces = (): string =>
  Object.values(declaration).map(declareFont).join(' ')

const fonts: Fonts = {
  Marianne: defineFont(declaration.Marianne),
  MarianneBold: defineFont(declaration.MarianneBold),
  MarianneMedium: defineFont(declaration.MarianneMedium),
  HelveticaNeue: defineFont(declaration.HelveticaNeue),
  HelveticaNeueBold: defineFont(declaration.HelveticaNeueBold),
  HelveticaNeueMedium: defineFont(declaration.HelveticaNeueMedium),
  HelveticaNeueLt: defineFont(declaration.HelveticaNeueLt),
  HelveticaNeueBoldCondensed: defineFont(
    declaration.HelveticaNeueBoldCondensed
  ),
}

export default fonts
